import {
  GET_ALL_TENANTS_START, GET_ALL_TENANTS_SUCCESS, GET_ALL_TENANTS_FAIL,
  ADD_TENANT_START, ADD_TENANT_SUCCESS, ADD_TENANT_FAIL,
  UPDATE_TENANT_START, UPDATE_TENANT_SUCCESS, UPDATE_TENANT_FAIL,
  DELETE_TENANT_START, DELETE_TENANT_SUCCESS, DELETE_TENANT_FAIL,
} from '../constants/tenants';
import { getAllTenantsApi, addTenantApi, updateTenantApi, deleteTenantApi } from '../../apis/tenants';

export function getAllTenants() {
  return (dispatch) => {
    dispatch({ type: GET_ALL_TENANTS_START });
    getAllTenantsApi().then(
      (res) => dispatch({ type: GET_ALL_TENANTS_SUCCESS, payload: res }),
      () => dispatch({ type: GET_ALL_TENANTS_FAIL })
    );
  };
}

export function addTenant(payload) {
  return (dispatch) => {
    dispatch({ type: ADD_TENANT_START });
    return addTenantApi(payload).then(
      (res) => dispatch({ type: ADD_TENANT_SUCCESS, payload: res }),
      () => dispatch({ type: ADD_TENANT_FAIL })
    );
  };
}

export function updateTenant(id, payload) {
  return (dispatch) => {
    dispatch({ type: UPDATE_TENANT_START });
    return updateTenantApi(id, payload).then(
      (res) => dispatch({ type: UPDATE_TENANT_SUCCESS, payload: res }),
      () => dispatch({ type: UPDATE_TENANT_FAIL })
    );
  };
}

export function deleteTenant(id) {
  return (dispatch) => {
    dispatch({ type: DELETE_TENANT_START });
    return deleteTenantApi(id).then(
      () => dispatch({ type: DELETE_TENANT_SUCCESS, payload: id }),
      () => dispatch({ type: DELETE_TENANT_FAIL })
    );
  };
}
